'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _yesterdayEpoch = require('./yesterdayEpoch');

var _yesterdayEpoch2 = _interopRequireDefault(_yesterdayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return new Date((0, _yesterdayEpoch2.default)() * 1000).toISOString().slice(0, 10);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/yesterdayUTCString.js
// module id = 80
// module chunks = 0